import { Country } from '../models/country.model';
import { ListItem } from '../models/ListItem';
import GenericService from './genericService';

class CountryService extends GenericService<Country, ListItem> {
  constructor() {
    super('/api/Countries');
  }
}
export const countryService = new CountryService();
